var _path, _path2, _path3, _path4, _path5, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLightMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6418 13.9934C29.7542 14.1111 29.8424 14.2496 29.9014 14.4009C29.9651 14.5539 29.9986 14.7177 30 14.8833H18.1345L14.8456 14.8472C14.8456 14.8472 13.0286 14.8936 11.6424 14.8936H5.45139H0.000181516C-0.00271625 14.7281 0.0291097 14.5639 0.093631 14.4113C0.156299 14.2581 0.249953 14.1194 0.368787 14.0037L5.11653 9.28594L8.16921 6.25511L14.0877 0.371438C14.2047 0.25341 14.3441 0.159603 14.4978 0.0954391C14.6528 0.0326619 14.8185 0.000253812 14.9858 0C15.1523 0.000585393 15.3171 0.0329873 15.4712 0.0954391C15.6258 0.159546 15.766 0.253339 15.884 0.371438L21.8543 6.28865L24.9511 9.35043L29.6418 13.9934Z",
    fill: "url(#paint0_linear_4206_55545)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5258 16.2783L15.8881 24.8017C15.6407 25.0488 15.3273 25.1682 14.9909 25.1682C14.6545 25.1682 14.3319 25.0364 14.0937 24.8017L5.44561 16.2783H6.12301e-05C-0.00158958 16.4426 0.0301553 16.6055 0.0934137 16.7574C0.156017 16.9095 0.249573 17.0473 0.368284 17.1622L14.0963 30.6915C14.2123 30.8104 14.3517 30.9045 14.506 30.9682C14.6604 31.0321 14.8261 31.0652 14.9935 31.0656C15.1609 31.0657 15.3267 31.0326 15.481 30.9682C15.6352 30.9045 15.7746 30.8104 15.8907 30.6915L29.6316 17.1622C29.7503 17.0467 29.8446 16.9091 29.9091 16.7574C29.9715 16.6053 30.0024 16.4424 29.9999 16.2783H24.5258Z",
    fill: "url(#paint1_linear_4206_55545)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4861 25.0818C15.2961 25.7431 17.1421 27.2733 18.4043 28.2368C18.3985 28.2106 15.6493 31.1118 15.4891 31.1796C15.3347 31.2449 15.1689 31.2785 15.0013 31.2783C14.8338 31.278 14.668 31.2444 14.5136 31.1796C14.3592 31.115 14.2198 31.0195 14.1036 30.8989L0.368477 17.1749C0.249704 17.0583 0.156098 16.9186 0.0934625 16.7643C0.030171 16.6102 -0.00159041 16.4449 6.12621e-05 16.2783H5.44846L13.8456 24.5718C14.034 24.7418 14.3919 25.0441 14.4861 25.0818Z",
    fill: "url(#paint2_linear_4206_55545)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M19.432 27.2122C19.405 27.2392 18.4164 28.2278 18.4164 28.2278L16.4604 26.6856L14.5421 25.1058L15.9081 25.5821L17.986 26.4263L19.6094 27.0757C19.6094 27.0757 19.5073 27.137 19.432 27.2122Z",
    fill: "url(#paint3_linear_4206_55545)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4206_55545",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 15
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5135 13.9153C29.6254 14.0313 29.7132 14.1677 29.7719 14.3168C29.8354 14.4676 29.8687 14.629 29.8701 14.7921H18.056L14.7814 14.7565C14.7814 14.7565 12.9722 14.8023 11.592 14.8023H5.42779H0.000180731C-0.00270449 14.6392 0.0289837 14.4774 0.0932256 14.327C0.155622 14.1761 0.248871 14.0394 0.367191 13.9254L5.09438 9.27679L8.13384 6.29039L14.0267 0.492947C14.1432 0.376649 14.282 0.284217 14.435 0.220993C14.5893 0.159136 14.7543 0.127203 14.9209 0.126953C15.0867 0.12753 15.2508 0.159457 15.4043 0.220993C15.5581 0.284161 15.6978 0.376579 15.8152 0.492947L21.7597 6.32343L24.8431 9.34033L29.5135 13.9153Z",
    fill: "url(#paint4_linear_4206_55545)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4206_55545)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6278,
    height: 18.0409,
    transform: "matrix(0.728994 -0.68452 0.712595 0.701576 -0.902344 13.9863)",
    fill: "url(#paint5_linear_4206_55545)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4206_55545",
    x1: 11.4286,
    y1: 0.844153,
    x2: 26.7526,
    y2: 16.2309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864583,
    stopColor: "#343761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343761"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4206_55545",
    x1: 15,
    y1: 16.2783,
    x2: 15,
    y2: 31.0656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CC6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5712F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4206_55545",
    x1: 7.81659,
    y1: 16.2783,
    x2: 7.81659,
    y2: 31.2783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4141F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CC9FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4206_55545",
    x1: 16.3626,
    y1: 27.5951,
    x2: 17.531,
    y2: 26.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F187C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4137CD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4206_55545",
    x1: 14.1017,
    y1: 4.16325,
    x2: 20.366,
    y2: 14.3583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864583,
    stopColor: "#343761"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4206_55545",
    x1: 7.85,
    y1: 4.96195,
    x2: 16.4902,
    y2: 9.64448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864583,
    stopColor: "#343761"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLightMobile);
export default __webpack_public_path__ + "static/media/logoLightMobile.68e12e26fc62f5cf137b583079df71cc.svg";
export { ForwardRef as ReactComponent };